import { render, staticRenderFns } from "./SendWhatsappTemplateMessage.vue?vue&type=template&id=bc855cd6"
import script from "./SendWhatsappTemplateMessage.vue?vue&type=script&lang=js"
export * from "./SendWhatsappTemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./SendWhatsappTemplateMessage.vue?vue&type=style&index=0&id=bc855cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports